import { render, staticRenderFns } from "./ArchiveRequestForm.vue?vue&type=template&id=e8dab4a8&scoped=true"
import script from "./ArchiveRequestForm.vue?vue&type=script&lang=ts"
export * from "./ArchiveRequestForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dab4a8",
  null
  
)

export default component.exports